module.exports = __webpack_public_path__ + "static/joyful_1-5a64e437b0b7abc923bdd62eccd9451d.jpg";